<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/performanceProductList' }">绩效产品</el-breadcrumb-item>
                <el-breadcrumb-item>绩效产品{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button
                        size="small"
                        plain
                        @click="submit('submitForm')"
                        :loading="btnLoading"
                        :disabled="pageLoading || !formReady"
                    >保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form
                        v-loading="pageLoading"
                        :model="formData"
                        :rules="rules"
                        ref="submitForm"
                        label-position="right"
                        class="details_temp2023"
                    >
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="pageLoading || (type == 'update' && item['prop'] == 'parent_rid')"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="pageLoading || item['prop'] == 'aaaaa'"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit, checkNumber } from '@/js/common.js';

export default {
    name: 'performanceProductEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            pageLoading: false,
            formReady: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.pageLoading = true;
            this.formReady = false;
            this.getData();
        } else {
            this.initFormData();
            this.formReady = true;
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                performance_unit_code: {
                    request_uri: 'dropdownPerformanceUnit',
                    title: '绩效单元',
                    ref: 'performance_unit_code_ref',
                    type: 'dropdown',
                    select_value: 'code'
                },
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown',
                    request_params: { type_code: [11, 15, 91] }
                }
            };
        },
        initFormRule() {
            this.rules = {
                performance_unit_code: [{ required: true, message: '请选择绩效单元', trigger: 'blur' }],
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                target_quantity: { required: true, validator: checkNumber, trigger: 'blur' },
                target_price_taxincluded: { required: true, validator: checkNumber, trigger: 'blur' },
                target_sales_standard_revenue: { required: true, validator: checkNumber, trigger: 'blur' },
                target_key_net_price_taxincluded: { required: true, validator: checkNumber, trigger: 'blur' },
                target_sales_net_revenue: { required: true, validator: checkNumber, trigger: 'blur' }
            };
        },

        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        initFormData() {
            const data = this.data || {};
            const hasValue = (value) => value !== undefined && value !== null;
            this.formData = {
                id: this.type === 'update' ? data.id || '' : '',
                performance_unit_code: hasValue(data.performance_unit_code) ? data.performance_unit_code : '',
                product_rid: hasValue(data.product_rid) ? data.product_rid : '',
                target_quantity: hasValue(data.target_quantity) ? data.target_quantity : '',
                target_price_taxincluded: hasValue(data.target_price_taxincluded) ? data.target_price_taxincluded : '',
                target_sales_standard_revenue: hasValue(data.target_sales_standard_revenue) ? data.target_sales_standard_revenue : '',
                target_key_net_price_taxincluded: hasValue(data.target_key_net_price_taxincluded) ? data.target_key_net_price_taxincluded : '',
                target_sales_net_revenue: hasValue(data.target_sales_net_revenue) ? data.target_sales_net_revenue : ''
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).performance_product;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['target_quantity', 'target_price_taxincluded', 'target_sales_standard_revenue','target_key_net_price_taxincluded','target_sales_net_revenue']
                },
                {
                    performance_unit_name: 'performance_unit_code',
                    product: 'product_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: 'performanceProductList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.pageLoading = true;
            this.formReady = false;
            this.$api
                .performanceProductDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data || {};
                    this.initFormData();
                    this.formReady = true;
                })
                .catch((error) => {
                    this.formReady = false;
                })
                .finally(() => {
                    this.pageLoading = false;
                });
        },
        //提交新增/编辑修改
        submit(formName) {
            if (this.pageLoading || !this.formReady || this.btnLoading) {
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            if (this.pageLoading || !this.formReady || this.btnLoading) {
                return false;
            }
            this.btnLoading = true;

            // ✅ 修复：提交前将 target_sales_net_revenue 从字符串转为数字类型，避免后端处理异常
            const submitData = { ...this.formData };
            if (submitData.target_sales_net_revenue !== '' && submitData.target_sales_net_revenue !== null) {
                submitData.target_sales_net_revenue = Number(submitData.target_sales_net_revenue);
            }

            let uri = '';
            if (this.type == 'update') {
                uri = 'performanceProductUpdate';
            } else {
                uri = 'performanceProductInsert';
            }
            this.$api[uri](submitData)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                    }

                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>